import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RestoreIcon from "@mui/icons-material/Restore";
import { Tooltip } from "@mui/material";

export default function ActionButtons({
    row,
    status,
    onEdit,
    onDelete,
    onRestore,
    onPermanentDelete,
    canEdit = true,
    canDelete = true
}) {
    const isInactive = (status || "").toLowerCase() === "inactive";
    console.log("STATUS VALUE:", status);

    return (
        <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>

            {/* EDIT */}
            <Tooltip title="Edit">
                <button
                    style={styles.editBtn}
                    onClick={() => onEdit(row)}
                    disabled={!canEdit}
                >
                    <EditIcon fontSize="small" />
                </button>
            </Tooltip>

            {isInactive ? (
                <>
                    {/* RESTORE */}
                    <Tooltip title="Restore">
                        <button
                            style={styles.restoreBtn}
                            onClick={() => onRestore(row)}
                            disabled={!canEdit}
                        >
                            <RestoreIcon fontSize="small" />
                        </button>
                    </Tooltip>

                    {/* PERMANENT DELETE */}
                    {canDelete && (
                        <Tooltip title="Delete Permanently">
                            <button
                                style={styles.deleteBtn}
                                onClick={() => onPermanentDelete(row)}
                            >
                                <DeleteIcon fontSize="small" />
                            </button>
                        </Tooltip>
                    )}
                </>
            ) : (
                <Tooltip title="Delete">
                    <button
                        style={styles.deleteBtn}
                        onClick={() => onDelete(row)}
                        disabled={!canDelete}
                    >
                        <DeleteIcon fontSize="small" />
                    </button>
                </Tooltip>
            )}
        </div>
    );
}

const styles = {
    editBtn: {
        background: "#2ed573",
        border: "none",
        padding: "5px",
        borderRadius: "4px",
        cursor: "pointer"
    },
    deleteBtn: {
        background: "#ff4757",
        border: "none",
        padding: "5px",
        borderRadius: "4px",
        cursor: "pointer"
    },
    restoreBtn: {
        background: "#3b82f6",
        border: "none",
        padding: "5px",
        borderRadius: "4px",
        cursor: "pointer",
        color: "#fff"
    }
};